import axios from '../axios'
// 开票申请列表
export const getFinInvoiceApplyPage = (data) => {
  return axios({
    url: '/api/sys/fin/getFinInvoiceApplyPage',
    method: 'post',
    data
  })
}
// 开票申请列表保存
export const saveFinInvoiceApply = (data) => {
  return axios({
    url: '/api/sys/fin/saveFinInvoiceApply',
    method: 'post',
    data
  })
}
// 开票申请列表修改
export const updateFinInvoiceApply = (data) => {
  return axios({
    url: '/api/sys/fin/updateFinInvoiceApply',
    method: 'post',
    data
  })
}
// 开票申请列表删除
export const deleteFinInvoiceApplys = (data) => {
  return axios({
    url: '/api/sys/fin/deleteFinInvoiceApplys',
    method: 'post',
    data
  })
}
// 开票申请列表审核
export const auditFinInvoiceApply = (data) => {
  return axios({
    url: '/api/sys/fin/auditFinInvoiceApply',
    method: 'post',
    data
  })
}

// 开票申请明细列表
export const getFinInvoiceApplyEntryPage = (data) => {
  return axios({
    url: '/api/sys/fin/getFinInvoiceApplyEntryPage',
    method: 'post',
    data
  })
}

// 开票申请明细删除
export const deleteFinInvoiceApplyEntrys = (data) => {
  return axios({
    url: '/api/sys/fin/deleteFinInvoiceApplyEntrys',
    method: 'post',
    data
  })
}

// 开票申请明细保存
export const saveFinInvoiceApplyEntry = (data) => {
  return axios({
    url: '/api/sys/fin/saveFinInvoiceApplyEntry',
    method: 'post',
    data
  })
}

// 开票信息列表
export const getFinInvoicePage = (data) => {
  return axios({
    url: '/api/sys/fin/getFinInvoicePage',
    method: 'post',
    data
  })
}

// 开票明细列表
export const getFinInvoiceEntryPage = data => {
  return axios({
      url: '/api/sys/fin/getFinInvoiceEntryPage',
      method: 'post',
      data
  })
};

// 上传开票图片
export const updateApplyImg = data => {
  return axios({
      url: '/api/sys/fin/updateApplyImg',
      method: 'post',
      data
  })
};
// 开票信息总合计
export const getFinInvoiceSum = data => {
  return axios({
      url: '/api/sys/fin/getFinInvoiceSum',
      method: 'post',
      data
  })
};
// 开票申请总合计
export const getFinInvoiceApplySum = data => {
  return axios({
      url: '/api/sys/fin/getFinInvoiceApplySum',
      method: 'post',
      data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/Invoicing.js